import dayjs from 'dayjs';

export const findEndDate = (startDate: string) => {
  const month = dayjs(startDate).month() + 1;
  const year = dayjs(startDate).year();
  if (month >= 4 && month < 7) return `${year}-06-30`;
  if (month >= 7 && month < 10) return `${year}-09-30`;
  if (month >= 1 && month < 4) return `${year}-03-31`;
  return `${year}-12-31`;
};
